import React from 'react';

import { FallbackProps } from 'react-error-boundary';

import { Button } from './Button';
import { Icon } from './icons';

const MapErrorFallback: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
  const { MapLocation } = Icon();

  return (
    <div
      role="alert"
      className="flex h-full w-full flex-col items-center justify-center gap-1.5 rounded-md border border-gray-200 bg-gray-50 px-4 text-center"
    >
      <MapLocation className="wh-7 fill-gray-300" />
      <p className="break-keep text-14 font-medium text-gray-500">
        현재 지도 서버의 문제로 인해 지도를 사용할 수 없습니다.
      </p>
      <p className="break-keep text-12 text-gray-400">잠시 후 다시 시도해 주세요.</p>
      <Button
        className="mt-1.5 h-8 rounded-md border border-gray-300 bg-white px-4 text-12 text-gray-600"
        text="다시 시도"
        onClick={resetErrorBoundary}
      />
    </div>
  );
};

export { MapErrorFallback };
